import * as track from 'lib/gaTracking/bookingListPageEvents';
import * as crossPageTrack from 'lib/gaTracking/crossPageEvents';
import { CardProps } from '../types';
import { CardWrapper, CardImage, InfoWrapper, Heading, SubHeading, StayInfo, Hr, ItemLinks } from '../Components';
import { useBookingList } from 'pages/BookingListPage/BookingListProvider';

const PastBookingCard = ({ booking, index, ...rest }: CardProps) => {
  const { sendViewBookingEvent } = useBookingList();

  const {
    id,
    links,
    image,
    reservation: { property },
  } = booking;

  const trackViewBookingEvent = () => sendViewBookingEvent(id);

  const detailsLink = {
    label: 'View details',
    url: links.manage,
    onClick: () => {
      track.viewDetailsLink(booking);
      trackViewBookingEvent();
    },
  };

  const rebookLink = {
    label: 'Book again',
    url: links.rebook,
    external: true,
    onClick: crossPageTrack.bookAgainLink,
    target: '_blank',
  };

  const itemLinks = [detailsLink, rebookLink];

  return (
    <CardWrapper>
      <CardImage {...image} link={detailsLink} onClick={trackViewBookingEvent} />
      <InfoWrapper bookingId={booking.id} {...rest}>
        <Heading>{property.name}</Heading>
        <SubHeading>{property.address.suburb}</SubHeading>

        <StayInfo booking={booking} />
      </InfoWrapper>

      <Hr />

      <ItemLinks links={itemLinks} />
    </CardWrapper>
  );
};

PastBookingCard.displayName = 'PastBookingCard';

export { PastBookingCard };
